import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './highest-level-of-qualification.reducer';

export const HighestLevelOfQualificationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const highestLevelOfQualificationEntity = useAppSelector(state => state.highestLevelOfQualification.entity);
  const loading = useAppSelector(state => state.highestLevelOfQualification.loading);
  const updating = useAppSelector(state => state.highestLevelOfQualification.updating);
  const updateSuccess = useAppSelector(state => state.highestLevelOfQualification.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/highest-level-of-qualification${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAllUsualResidents !== undefined && typeof values.totalAllUsualResidents !== 'number') {
      values.totalAllUsualResidents = Number(values.totalAllUsualResidents);
    }
    if (values.noQualifications !== undefined && typeof values.noQualifications !== 'number') {
      values.noQualifications = Number(values.noQualifications);
    }
    if (values.level1Qualifications !== undefined && typeof values.level1Qualifications !== 'number') {
      values.level1Qualifications = Number(values.level1Qualifications);
    }
    if (values.level2Qualifications !== undefined && typeof values.level2Qualifications !== 'number') {
      values.level2Qualifications = Number(values.level2Qualifications);
    }
    if (values.apprenticeship !== undefined && typeof values.apprenticeship !== 'number') {
      values.apprenticeship = Number(values.apprenticeship);
    }
    if (values.level3Qualifications !== undefined && typeof values.level3Qualifications !== 'number') {
      values.level3Qualifications = Number(values.level3Qualifications);
    }
    if (values.level4QualificationsAndAbove !== undefined && typeof values.level4QualificationsAndAbove !== 'number') {
      values.level4QualificationsAndAbove = Number(values.level4QualificationsAndAbove);
    }
    if (values.otherQualifications !== undefined && typeof values.otherQualifications !== 'number') {
      values.otherQualifications = Number(values.otherQualifications);
    }

    const entity = {
      ...highestLevelOfQualificationEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...highestLevelOfQualificationEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="apiLocationApp.highestLevelOfQualification.home.createOrEditLabel"
            data-cy="HighestLevelOfQualificationCreateUpdateHeading"
          >
            <Translate contentKey="apiLocationApp.highestLevelOfQualification.home.createOrEditLabel">
              Create or edit a HighestLevelOfQualification
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="highest-level-of-qualification-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.highestLevelOfQualification.geographicLevel')}
                id="highest-level-of-qualification-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.highestLevelOfQualification.date')}
                id="highest-level-of-qualification-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.highestLevelOfQualification.geography')}
                id="highest-level-of-qualification-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.highestLevelOfQualification.geographyCode')}
                id="highest-level-of-qualification-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.highestLevelOfQualification.totalAllUsualResidents')}
                id="highest-level-of-qualification-totalAllUsualResidents"
                name="totalAllUsualResidents"
                data-cy="totalAllUsualResidents"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.highestLevelOfQualification.noQualifications')}
                id="highest-level-of-qualification-noQualifications"
                name="noQualifications"
                data-cy="noQualifications"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.highestLevelOfQualification.level1Qualifications')}
                id="highest-level-of-qualification-level1Qualifications"
                name="level1Qualifications"
                data-cy="level1Qualifications"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.highestLevelOfQualification.level2Qualifications')}
                id="highest-level-of-qualification-level2Qualifications"
                name="level2Qualifications"
                data-cy="level2Qualifications"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.highestLevelOfQualification.apprenticeship')}
                id="highest-level-of-qualification-apprenticeship"
                name="apprenticeship"
                data-cy="apprenticeship"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.highestLevelOfQualification.level3Qualifications')}
                id="highest-level-of-qualification-level3Qualifications"
                name="level3Qualifications"
                data-cy="level3Qualifications"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.highestLevelOfQualification.level4QualificationsAndAbove')}
                id="highest-level-of-qualification-level4QualificationsAndAbove"
                name="level4QualificationsAndAbove"
                data-cy="level4QualificationsAndAbove"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.highestLevelOfQualification.otherQualifications')}
                id="highest-level-of-qualification-otherQualifications"
                name="otherQualifications"
                data-cy="otherQualifications"
                type="text"
              />
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/highest-level-of-qualification"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default HighestLevelOfQualificationUpdate;
